import { ComponentChild, h } from 'preact'
import Panel from '../panel'

const FeaturedTopicsModeratorTags = ({ dragHandle, switcher }: {dragHandle: ComponentChild, switcher: ComponentChild}) => {
  return (
    <Panel class='homepage-widget' title={<div className='panel-title-with-switch'>
      <div className='homepage-reorderable-panel-title'>
        { dragHandle }
        <span>Featured topics (moderator tags)</span>
      </div>
      {switcher}
    </div>} />
  )
}

export default FeaturedTopicsModeratorTags
